const addClassReducer = (state = {}, action) => {
    switch (action.type) {
      case "ADD_CLASS": {
        return{
          ...state,
          addClassSuccess: action.success
        }
      }
      case "ADD_CLASS_ERR": {
        return{
          ...state,
          addClassError: action.err
        }
      }
      default:
        return state;
    }
  };
  
  export default addClassReducer;
  